import { getMediaProvider, getMediaSearchChannels } from '../providers/registry.js'
import {
    WORTH_WATCHING_SIZE,
    createWorthWatchingFeedService,
} from '../services/worthWatchingFeed.js'

function requiredProvider(id, method) {
    let provider = getMediaProvider(id)
    if (!provider || typeof provider[method] !== 'function') {
        throw new Error(`Provider ${id} does not support ${method}`)
    }
    return provider
}

let requestSequence = 0

const feedService = createWorthWatchingFeedService({
    async fetchCinema() {
        const channel = getMediaSearchChannels().find((item) => item.id === 'cinema')
        const providers = (channel?.providerIds || []).map(getMediaProvider)
            .filter((provider) => typeof provider?.discoverTop === 'function')
        const results = await Promise.allSettled(providers.map((provider) => provider.discoverTop({ page: 1, limit: 100 })))
        const successful = results.filter((result) => result.status === 'fulfilled')
        if (!successful.length) throw new Error('Cinema discovery unavailable')
        return successful.flatMap((result) => result.value)
    },
    fetchAnime({ now }) {
        return requiredProvider('kodik', 'discoverRecentAnime').discoverRecentAnime({
            limit: 100,
            now,
        })
    },
    config: { size: WORTH_WATCHING_SIZE },
})

export default {
    state: {
        worth_watching: [],
        worth_watching_status: 'idle',
        worth_watching_error: '',
    },
    getters: {
        get_worth_watching: (state) => state.worth_watching,
        get_worth_watching_status: (state) => state.worth_watching_status,
        get_worth_watching_error: (state) => state.worth_watching_error,
    },
    actions: {
        request_worth_watching(ctx, payload = {}) {
            let sequence = ++requestSequence
            let force = Boolean(payload && payload.force)
            let cached = feedService.read()
            if (cached) {
                ctx.commit('SET_WORTH_WATCHING', cached.items)
                ctx.commit('SET_WORTH_WATCHING_STATUS', cached.stale ? 'refreshing' : 'success')
                ctx.commit('SET_WORTH_WATCHING_ERROR', '')
                if (!cached.stale && !force) return Promise.resolve(cached.items)
            } else {
                ctx.commit('SET_WORTH_WATCHING_STATUS', 'loading')
                ctx.commit('SET_WORTH_WATCHING_ERROR', '')
            }

            return feedService.refresh({ force }).then((snapshot) => {
                if (sequence !== requestSequence) return ctx.state.worth_watching
                ctx.commit('SET_WORTH_WATCHING', snapshot.items)
                ctx.commit('SET_WORTH_WATCHING_STATUS', 'success')
                ctx.commit('SET_WORTH_WATCHING_ERROR', '')
                return snapshot.items
            }).catch((error) => {
                if (sequence !== requestSequence) return ctx.state.worth_watching
                if (cached) {
                    ctx.commit('SET_WORTH_WATCHING_STATUS', 'success')
                    return cached.items
                }
                ctx.commit('SET_WORTH_WATCHING', [])
                ctx.commit('SET_WORTH_WATCHING_STATUS', 'error')
                ctx.commit('SET_WORTH_WATCHING_ERROR', 'Не удалось загрузить рекомендации.')
                throw error
            })
        },
        invalidate_worth_watching(ctx) {
            requestSequence++
            feedService.invalidate()
            ctx.commit('SET_WORTH_WATCHING', [])
            ctx.commit('SET_WORTH_WATCHING_STATUS', 'idle')
            ctx.commit('SET_WORTH_WATCHING_ERROR', '')
        },
    },
    mutations: {
        SET_WORTH_WATCHING(state, items) {
            state.worth_watching = Array.isArray(items) ? items : []
        },
        SET_WORTH_WATCHING_STATUS(state, status) {
            state.worth_watching_status = status
        },
        SET_WORTH_WATCHING_ERROR(state, error) {
            state.worth_watching_error = error
        },
    },
}
